<template>
  <div>
    <b-row class="justify-content-md-center">
      <b-col col lg="6">
        <b-alert variant="success" :show="sucessMailSend">{{ $t('recover_pass.mail_sended') }}</b-alert>
        <b-alert variant="warning" :show="sucessMailAlreadySend">{{ $t('recover_pass.mail_sended_already') }}</b-alert>
        <b-alert variant="danger" :show="sucessMailAlreadyDangerSend">{{ $t('recover_pass.mail_sended_already_danger') }}</b-alert>
        <b-form @submit="onSubmit" v-if="show">
          <b-form-group 
            id="group1"
            class="text-left"
            :label="$t('recover_pass.email_label')"
            label-for="mailinput"
            :invalid-feedback="form_invalid_feedback.email"
            :state="form_state.email"            
          >
            <b-form-input
              id="mailinput"
              v-model.trim="form.email"
              type="text"
              required
              :state="form_state.email"
              :placeholder="$t('recover_pass.email_placeholder')"
            >
            </b-form-input>
          </b-form-group>

          <b-row class="text-left  mt-5" no-gutters>
            <b-col cols="12" md="6">
              <b-button type="submit" size="xl" variant="primary-b">{{ $t('recover_pass.submit_button') }}</b-button>
            </b-col>
          </b-row>
          <b-row class="text-left mt-4">
            <b-col cols="12" md="6">
              <router-link :to="{name: 'login'}">{{ $t('recover_pass.back_to_login') }}</router-link>
            </b-col>
          </b-row>
        </b-form>

      </b-col>
    </b-row>
  </div>
</template>


<script>
export default {
  name: "recover-pass",
  data() {
    return {
      sucessMailSend: false,
      sucessMailAlreadySend: false,
      sucessMailAlreadyDangerSend: false,
      form: {
        email: "",
      },
      form_invalid_feedback: {},
      form_state: {},
      show: true,
    };
  },
  fallbackI18n: {
    messages: {
      und: {
        recover_pass: {
          email_label: "Email",
          email_placeholder: "Enter email",
          submit_button: "Recover password",
          back_to_login: "Back to login",
          mail_sended: "We have sent an email with instructions.",
          mail_sended_already:
            "We have already sent an email with instructions. Please, check your inbox.",
          mail_sended_already_danger:
            "Sorry for the inconvenience. We have already sent an email with instructions. Contact with our team if you have not received it.",
        },
      },
    },
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$recaptcha("recover_pass_form").then(
        token => {
          this.$store.dispatch("auth/RECOVER_PASS", {
            ...this.form,
            recaptcha_token: String(token),
          }).then(
            response => {
              this.showFeedback({ state: true, response: response });
              this.$emit("recover:submit", { state: true, response: response });
            },
            err => {
              this.$emit("recover:submit", {
                state: false,
                response: err.response,
              });
              this.showFeedback({ state: false, response: err.response });
              this.showResponseError(err.response);
              this.putFormFeedback(err.response);
            }
          );
        },
        err => {
          this.$sentry({ capture: err });
          this.$emit("recover:submit", {
            state: false,
            response: err.response,
          });
          this.showFeedback({ state: false, response: err.response });
          this.showResponseError(err.response);
          this.putFormFeedback(err.response);
        }
      );
    },
    showFeedback(data) {
      // danger message
      if (data.state && this.sucessMailAlreadySend) {
        this.sucessMailAlreadySend = false;
        this.sucessMailSend = false;
        this.sucessMailAlreadyDangerSend = true;
        // warning message
      } else if (data.state && this.sucessMailSend) {
        this.sucessMailAlreadySend = true;
        this.sucessMailSend = false;
        this.sucessMailAlreadyDangerSend = false;
        // success message
      } else if (data.state && !this.sucessMailAlreadyDangerSend) {
        this.sucessMailSend = true;
        this.sucessMailAlreadyDangerSend = false;
        this.sucessMailAlreadySend = false;
      }
    },
  },
};
</script>


<style lang="scss">
</style>
